module.exports = __webpack_public_path__ + "img/us-in.f6373366.svg";